var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 24C48 28.7468 46.5924 33.3869 43.9553 37.3337C41.3181 41.2805 37.5698 44.3566 33.1844 46.1731C28.799 47.9896 23.9734 48.4649 19.3178 47.5388C14.6623 46.6128 10.3859 44.327 7.02944 40.9706C3.67298 37.6141 1.3872 33.3377 0.461153 28.6822C-0.464892 24.0266 0.0103881 19.201 1.82689 14.8156C3.64339 10.4302 6.71953 6.68188 10.6663 4.04473C14.6131 1.40758 19.2532 -5.66044e-08 24 0L24 4.80043C20.2027 4.80043 16.4906 5.92646 13.3333 8.03614C10.1759 10.1458 7.71508 13.1444 6.26191 16.6526C4.80874 20.1609 4.42852 24.0213 5.16934 27.7457C5.91016 31.47 7.73874 34.891 10.4239 37.5761C13.109 40.2613 16.53 42.0898 20.2543 42.8307C23.9787 43.5715 27.8391 43.1913 31.3474 41.7381C34.8556 40.2849 37.8542 37.8241 39.9639 34.6667C42.0735 31.5094 43.1996 27.7973 43.1996 24H48Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading2);
export default __webpack_public_path__ + "static/media/loading2.8b3ca0d56d4e9846067a1d810ed2291d.svg";
export { ForwardRef as ReactComponent };